/* eslint-disable import/no-cycle */

import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import Logger from '../../services/logger';
import UserGraph from './userGraph';
import StepMapper from './stepMapper';
import { FLOW_STEPS } from '../../constants';

export const FlowContext = React.createContext();

export const useFlowControl = () => useContext(FlowContext);

const InitialStep = UserGraph.nodes()[0];

const FlowControlProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(InitialStep);
  const [userJourney, setUserJourney] = useState([InitialStep]);

  const reStart = () => {
    setCurrentStep(InitialStep);
    setUserJourney([InitialStep]);
  };

  const reStartFromVerifyPhoneNumber = () => {
    setCurrentStep(FLOW_STEPS.VERIFY_PHONE_NUMBER);
    setUserJourney([InitialStep, FLOW_STEPS.VERIFY_PHONE_NUMBER]);
  };

  const goNext = (stepName) => {
    const nodeAdjacent = UserGraph.adjacent(currentStep);
    let nextStep;

    if (stepName) {
      nextStep = nodeAdjacent.includes(stepName) ? stepName : undefined;
    } else {
      [nextStep] = nodeAdjacent;
    }

    if (!nextStep) {
      Logger.error(`Failed to go next step from ${currentStep}.`);
      return;
    }

    setCurrentStep(nextStep);
    setUserJourney([...userJourney, nextStep]);
  };

  const goPrev = () => {
    const stateJourney = [...userJourney];
    stateJourney.pop();
    const prevStep = stateJourney[stateJourney.length - 1];

    if (!prevStep) {
      Logger.error(`No prev step found for ${currentStep}.`);
      return;
    }
    setCurrentStep(prevStep);
    setUserJourney(stateJourney);
  };

  const CompToRender = StepMapper[currentStep];

  return (
    <FlowContext.Provider
      value={{
        reStart,
        reStartFromVerifyPhoneNumber,
        currentStep,
        goNext,
        goPrev,
      }}
    >
      <>
        <CompToRender />
        {children}
      </>
    </FlowContext.Provider>
  );
};

FlowControlProvider.propTypes = {
  children: PropTypes.node,
};
FlowControlProvider.defaultProps = {
  children: null,
};

export default FlowControlProvider;
